import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useAuth } from "../Auth/AuthContext";
import TeamMemberApiService from "../../ApiServices/SettingApiServices/TeamMemberApiService";

Modal.setAppElement("#root");


// Set custom styles for the modal
const customStyles = {
    overlay: {
        backgroundColor: "rgba(0, 0, 0, 0.5)", // Dim the background
        zIndex: 1000, // Ensure the modal is on top
      },
      content: {
        top: "50%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        transform: "translate(-50%, -50%)",
        padding: "20px",
        borderRadius: "8px",
        boxShadow: "0 10px 50px rgba(0, 0, 0, 0.5)", // Enhanced shadow
        backgroundColor: "#fff",
        width: "400px",
        maxWidth: "90%", // Make it responsive
      },
};

const TeamMemberForm = () => {
  const [formData, setFormData] = useState({
    Username: "",
    Email: "",
    Password: "",
    PhoneNumber: "",
  });
  const [isUserExists, setIsUserExists] = useState(false); // Check if the user exists
  const [modalIsOpen, setModalIsOpen] = useState(false); // Modal state
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const Auth = useAuth();
  const user = Auth.authState.user;

  const checkUserExists = async () => {
    try {
      const users = await TeamMemberApiService.GetTeamMemByUserId(user.id);
      setIsUserExists(users.isSuccess && users.data != null); // Set flag based on user existence
      setFormData({
        Username: users.data.userName || "",
        Email: users.data.email || "",
        Password: users.data.password || "",
        PhoneNumber: users.data.phoneNumber || "",
    });
    } catch (error) {
      console.error("Error fetching users:", error);
      toast.error("Failed to fetch users.");
    }
  };
  // Check if a user exists when the component mounts
  useEffect(() => {
    

     checkUserExists();
  }, []);

  // Input change handler
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Submit handler for adding or inviting a member
  const handleInviteSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
        const teamMemberDetail = {
            ...formData,
            UserId: user.id, // Replace with dynamic Id if required
        };
      // Add a new user
      const result = await TeamMemberApiService.Add(teamMemberDetail);
      toast.success("Add Team Member successfully!");
      setFormData({
        Username: result.data.userName || "",
        Email: result.data.email || "",
        Password: result.data.password || "",
        PhoneNumber: result.data.phoneNumber || "",
    });
      setModalIsOpen(false); // Close the modal
      setIsUserExists(true); // Update flag to show update form
    } catch (error) {
      console.error("Error inviting user:", error);
      toast.error("Failed to invite user.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <ToastContainer />

      <div className="bg-white p-6 rounded-lg shadow-md mb-6" data-aos="fade-up">
        <h2 className="text-xl font-semibold mb-4">Team Member</h2>
        {!isUserExists ? (
          <button
            onClick={() => setModalIsOpen(true)}
            className="flex items-center justify-center text-orange-500 border border-orange-500 hover:bg-orange-500 hover:text-white transition-colors duration-300 focus:ring-4 focus:outline-none focus:ring-orange-300 font-medium rounded-lg text-sm px-4 py-2"
          >
            Invite Member
          </button>
        ) : (
           // Render Update Form Here
            <div>
                {/* <h3 className="text-gray-700 mb-2">Update Team Member</h3> */}
                <form onSubmit={handleInviteSubmit} className="space-y-4">
                    {["Username", "Email", "Password", "PhoneNumber"].map((field) => (
                        <div key={field} className="flex flex-col relative">
                        <label htmlFor={field} className="text-gray-600 mb-1">
                            {field}
                        </label>

                        {field === "Password" ? (
                            <div className="relative">
                            {/* Password Input */}
                            <input
                                type={showPassword ? "text" : "password"}
                                id={field}
                                name={field}
                                value={formData[field]}
                                onChange={handleInputChange}
                                className="border border-gray-300 rounded-md p-2 focus:outline-none focus:border-blue-500 w-full"
                                placeholder={`${field}`}
                            />
                            {/* Eye Icon for Toggle */}
                            <button
                                type="button"
                                onClick={() => setShowPassword((prev) => !prev)}
                                className="absolute inset-y-0 right-2 flex items-center text-gray-500"
                            >
                                {showPassword ? "👁️" : "👁️‍🗨️"}
                            </button>
                            </div>
                        ) : (
                            // Other Inputs
                            <input
                            type="text"
                            id={field}
                            name={field}
                            value={formData[field]}
                            onChange={handleInputChange}
                            className="border border-gray-300 rounded-md p-2 focus:outline-none focus:border-blue-500"
                            placeholder={`${field}`}
                            />
                        )}
                        </div>
                    ))}
                    <button
                        type="submit"
                        className="px-4 py-2 bg-blue-600 text-white rounded-md shadow-md hover:bg-blue-700 transition duration-200"
                        disabled={loading}
                    >
                        {loading ? "Updating..." : "Update"}
                    </button>
                </form>

            </div>
        )}
      </div>

      {/* Modal for inviting a member */}
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={() => setModalIsOpen(false)}
        style={customStyles}
      >
        <h2 className="text-lg font-semibold mb-4">Invite Team Member</h2>
        <form onSubmit={handleInviteSubmit} className="space-y-4">
          {["Username", "Email", "Password", "PhoneNumber"].map((field) => (
            <div key={field} className="flex flex-col">
              <label htmlFor={field} className="text-gray-600 mb-1">
                {field}
              </label>
              <input
                type="text"
                id={field}
                name={field}
                value={formData[field]}
                onChange={handleInputChange}
                className="border border-gray-300 rounded-md p-2 focus:outline-none focus:border-blue-500"
                placeholder={`Enter ${field}`}
                disabled={loading}
              />
            </div>
          ))}

          <div className="flex justify-between mt-6">
            <button
              type="submit"
              className="px-4 py-2 bg-blue-600 text-white rounded-md shadow-md hover:bg-blue-700 transition duration-200"
              disabled={loading}
            >
              {loading ? "Saving..." : "Invite"}
            </button>
            <button
              type="button"
              onClick={() => setModalIsOpen(false)}
              className="px-4 py-2 bg-gray-300 text-gray-800 rounded-md shadow-md hover:bg-gray-400 transition duration-200"
            >
              Close
            </button>
          </div>
        </form>
      </Modal>
    </>
  );
};

export default TeamMemberForm;
